import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();

  if (checking || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0B0E]">
        <Loader2 className="h-8 w-8 animate-spin text-[#0A8CF2]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
